import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

type TConfirmModal = {
  setModalVisible: (param: boolean) => void;
  onConfirm: () => void;
  confimLable?: keyof typeof translations;
  cancelLabel?: keyof typeof translations;
  title?: string;
  confirmMessage?: string | ReactElement;
  visible: boolean;
  isLoading?: boolean;
};

const ConfirmModal = ({
  setModalVisible,
  onConfirm,
  confimLable = 'confirm',
  cancelLabel = 'cancel',
  title = '',
  confirmMessage = 'message',
  visible = false,
  isLoading = false,
}: TConfirmModal) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    onConfirm();
    setModalVisible(false);
  };

  return (
    <Modal visible={visible} centered>
      <Dialog
        dialog={{
          heading: title,
          content: confirmMessage,
          footer: (
            <>
              <Button
                testId="delete-modal-button-delete"
                label={t(translations[confimLable])}
                colored
                loading={isLoading}
                disabled={isLoading}
                onClick={onDelete}
              />
              <Button label={t(translations[cancelLabel])} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const Container = withErrorBoundary(ConfirmModal, { style: { position: 'absolute', bottom: 0, zIndex: 1000 } });

export { Container as ConfirmModal };
